import RecargoDelete from './RecargoDelete'
export { RecargoDelete }
export default RecargoDelete
